import { AvailableBrokers } from '@ocp-zmarta/content-lib'
import Vue from 'vue'
import { getZmartaAnalytics } from '.'
import { isProduction } from '..'

/**
 * Initiate GA360 scripts and pageView event.
 * @param {String} site
 * @param {Object} gaPageView
 * @param {Object} cookies
 * @returns {Object}
 */
export function gtmEventPageView ({ site, gaPageView, cookies }) {
  if (!gaPageView || !site) return

  const [domain, countryCode] = site.split('.')
  const brand = AvailableBrokers.includes(domain) ? 'broker' : domain

  Vue.prototype.ZGA = getZmartaAnalytics({
    market: countryCode,
    brand,
    product: gaPageView.product,
    productFamily: gaPageView.productFamily,
    silence: isProduction
  })

  const {
    pageName = process.env.name,
    cg1,
    cg2,
    cg3,
    cg4,
    cg5
  } = gaPageView

  return Vue.prototype.ZGA.init({
    pageName,
    cg1,
    cg2,
    cg3,
    cg4,
    cg5,
    uid: (cookies && cookies.access_uuid) || ''
  })
}

/**
 * Send 404 gaPageView.
 * @param {String} url
 * @param {String} previousUrl
 */
export function gtmPageView404 ({ url, previousUrl = '-' }) {
  if (!url) return

  Vue.prototype.ZGA.event.page.error404Page({ url, previousUrl })
}
